import { NotificationList } from 'components/common/NotificationList'
import { put, takeLatest } from 'redux-saga/effects'
import {
  makeGetRequest,
  makePostRequest,
  makeReportsGetRequest,
  makeReportsPostRequest
} from 'utils/api'
import { formatResponse, formatErrorMessage } from 'utils/formatting'
import * as ACT from './actions'
import { PUSH_NOTIFICATION } from 'actions/actionTypes'

function* fetchLayout() {
  try {
    const url = '/v1/users/prefs/dashboard/layout'
    const layouts = yield makeGetRequest(url)
    yield put({
      type: ACT.LAYOUT_FETCH_SUCCESS,
      payload: {
        layouts
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue fetching Dashboard Layout',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* saveLayout(action) {
  const { content } = action.payload
  try {
    const url = '/v1/users/prefs/dashboard/layout'
    const layouts = yield makePostRequest(url, content)
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'Dashboard Layout has been saved!',
        level: 'success'
      }
    })
    yield put({
      type: ACT.LAYOUT_SAVE_SUCCESS,
      payload: {
        layouts
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue saving Dashboard Layout',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* fetchOverviewOffice(action) {
  try {
    const { office } = action.payload
    const url = '/v1/dashboard/pipeline'
    let payload = { team: office }
    if (office === 0) payload = {}
    const { stages } = yield makeReportsPostRequest(url, payload)
    yield put({
      type: ACT.OVERVIEW_OFFICE_FETCH_SUCCESS,
      payload: {
        overview: stages
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue fetching Overview from Dashboard',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* fetchOverviewUser(action) {
  try {
    const { userId } = action.payload
    const url = '/v1/dashboard/pipeline'
    let payload = { userId }
    if (userId === 0) payload = {}
    const { stages } = yield makeReportsPostRequest(url, payload)
    yield put({
      type: ACT.OVERVIEW_USER_FETCH_SUCCESS,
      payload: {
        overview: stages
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue fetching Overview from Dashboard',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* fetchMyTasks(action) {
  try {
    const { userId } = action.payload

    const url = '/v1/dashboard/userTasksReport?userId=' + userId
    const myTasks = yield makeReportsGetRequest(url)

    yield put({
      type: ACT.MY_TASKS_FETCH_DONE,
      payload: {
        myTasks
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue fetching My Tasks from Dashboard',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* fetchMyActive() {
  try {
    const url = '/v1/dashboard/activeDealsAndProposalsByStage'
    const myActive = yield makeReportsGetRequest(url)
    yield put({
      type: ACT.MY_ACTIVE_FETCH_DONE,
      payload: {
        myActive
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue fetching My Active from Dashboard',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* fetchOverviewAll(action) {
  const { stage } = action.payload
  try {
    const url = '/v1/dashboard/pipelineDetails'
    const overviewAll = yield makeReportsPostRequest(url, { stage })
    yield put({
      type: ACT.OVERVIEW_ALL_FETCH_SUCCESS,
      payload: {
        overviewAll
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue fetching Pipeline Details',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* fetchOverviewAllOffice(action) {
  try {
    const { officeId, stage } = action.payload
    const url = '/v1/dashboard/pipelineDetails'
    const overviewAll = yield makeReportsPostRequest(url, { stage, team: officeId })
    yield put({
      type: ACT.OVERVIEW_ALL_OFFICE_FETCH_SUCCESS,
      payload: {
        overviewAll
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue fetching Pipeline Details',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* fetchOverviewAllUser(action) {
  try {
    const { userId, stage } = action.payload
    const url = '/v1/dashboard/pipelineDetails'
    const overviewAll = yield makeReportsPostRequest(url, { stage, userId })
    yield put({
      type: ACT.OVERVIEW_ALL_USER_FETCH_SUCCESS,
      payload: {
        overviewAll
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue fetching Pipeline Details',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* fetchProposalsForReview() {
  try {
    const url = '/v1/dashboard/proposalsISentForReview'
    const { proposals } = yield makeReportsGetRequest(url)
    yield put({
      type: ACT.PROPOSALS_FOR_REVIEW_FETCH_DONE,
      payload: {
        proposalsISentForReview: proposals
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue fetching Proposals I Sent For Review',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* fetchProposalsToReview() {
  try {
    const url = '/v1/dashboard/proposalsINeedToReview'
    const { proposals } = yield makeReportsGetRequest(url)
    yield put({
      type: ACT.PROPOSALS_TO_REVIEW_FETCH_DONE,
      payload: {
        proposalsINeedToReview: proposals
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue fetching Proposals I Need To Review',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* fetchProposalsToUpdate() {
  try {
    const url = '/v1/dashboard/proposalsINeedToUpdate'
    const { proposals } = yield makeReportsGetRequest(url)
    yield put({
      type: ACT.PROPOSALS_UPDATE_FETCH_DONE,
      payload: {
        proposalsINeedToUpdate: proposals
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue fetching Proposals I Need To Update',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* fetchProposalsToClient() {
  try {
    const url = '/v1/dashboard/proposalsReadyToSentToClient'
    const { proposals } = yield makeReportsGetRequest(url)
    yield put({
      type: ACT.PROPOSALS_CLIENT_FETCH_DONE,
      payload: {
        proposalsReadyToSentToClient: proposals
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue fetching Proposals Ready To Sent To Client',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* fetchProposalsInReview() {
  try {
    const url = '/v1/reports/proposalsInReview'
    const proposalsInReview = yield makeGetRequest(url)
    yield put({
      type: ACT.GET_PROPOSALS_IN_REVIEW_FETCH_SUCCESS,
      payload: {
        proposalsInReview
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue fetching Proposals In Review',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

const dashboardSagas = [
  takeLatest(ACT.LAYOUT_FETCH_REQUESTED, fetchLayout),
  takeLatest(ACT.LAYOUT_SAVE_REQUESTED, saveLayout),
  takeLatest(ACT.OVERVIEW_OFFICE_FETCH_REQUESTED, fetchOverviewOffice),
  takeLatest(ACT.OVERVIEW_USER_FETCH_REQUESTED, fetchOverviewUser),
  takeLatest(ACT.MY_TASKS_FETCH_REQ, fetchMyTasks),
  takeLatest(ACT.MY_ACTIVE_FETCH_REQ, fetchMyActive),
  takeLatest(ACT.OVERVIEW_ALL_FETCH_REQUESTED, fetchOverviewAll),
  takeLatest(ACT.OVERVIEW_ALL_OFFICE_FETCH_REQUESTED, fetchOverviewAllOffice),
  takeLatest(ACT.OVERVIEW_ALL_USER_FETCH_REQUESTED, fetchOverviewAllUser),
  takeLatest(ACT.PROPOSALS_FOR_REVIEW_FETCH_REQ, fetchProposalsForReview),
  takeLatest(ACT.PROPOSALS_TO_REVIEW_FETCH_REQ, fetchProposalsToReview),
  takeLatest(ACT.PROPOSALS_UPDATE_FETCH_REQ, fetchProposalsToUpdate),
  takeLatest(ACT.PROPOSALS_CLIENT_FETCH_REQ, fetchProposalsToClient),
  takeLatest(ACT.GET_PROPOSALS_IN_REVIEW_FETCH_REQUESTED, fetchProposalsInReview)
]

export default dashboardSagas
